module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:none;}.a,.b{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}</style></defs><title>IG-01</title><circle class=\"a\" cx=\"24.96\" cy=\"25\" r=\"10.59\" transform=\"translate(-0.06 0.06) rotate(-0.15)\"></circle><circle class=\"b\" cx=\"38.67\" cy=\"12.21\" r=\"1.63\"></circle><rect class=\"a\" x=\"2.03\" y=\"2.07\" width=\"45.86\" height=\"45.86\" rx=\"10.63\" ry=\"10.63\" transform=\"translate(-0.06 0.06) rotate(-0.15)\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/IG.svg
// module id = 490
// module chunks = 1